import { AppService } from './../../app.service';
import { SharedService } from './../shared.service';
import { appConfig } from './../../app.config';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { tap } from 'rxjs/operators';
import { PermissionsList } from './permissions.model';
@Injectable()

export class PermissionService {
    isAdmin: boolean;
    permissionsData: string[] = [];
    permissionListModel = PermissionsList;
    constructor(
        public httpclient: HttpClient,
        public router: Router,
        public sharedService: SharedService,
        public appService: AppService
    ) { }

    /**
     * For getting permissions data
     */
    getPermissionsData() {
        this.sharedService.getUserAuthentication();
        const permissionUrl = appConfig.getPermissionList;
        return this.httpclient.get(permissionUrl, this.sharedService.getUserAuthentication()).pipe(tap(
            (response: any) => {
                this.isAdmin = response.data.isAdmin;
                this.setPermissions(response.data.permissions);
            },
            error => this.sharedService.error(error)));
    }

    getAllPermissionsData() {
        const allPermissionUrl = appConfig.getPermissionList;
        return this.sharedService.getData(allPermissionUrl);
    }

    getCurrentPermissions() {
        return this.permissionsData.length ? this.permissionsData : JSON.parse(localStorage.getItem('userPermissions'));
    }

    /**
     * To get all permission JSON
     */
    getPermissions() {
        const permissionUrl = appConfig.getPermissions;
        return this.sharedService.getData(permissionUrl);
    }
    /** set permissions
    *   @param permissions - permissions to set
    */
    setPermissions(permissions: string[]) {
        this.permissionsData = this.augmentPermissionList(permissions, this.permissionListModel);
        localStorage.setItem('userPermissions', JSON.stringify(this.permissionsData));
    }
    /**
     * To augment the permission list to convert url into keys
     * for adding permissions check
     * @param data Response
     * @param allPermissions All Permissions
     */
    augmentPermissionList(data, allPermissions) {
        for (let i = 0; i < data.length; i++) {
            for (let j = 0; j < allPermissions.length; j++) {
                if (data[i] === allPermissions[j].label) {
                    data[i] = allPermissions[j].value;
                }
            }
        }
        return data;
    }
}
